var Widget = require('./Widget'),
    $      = require("jquery");

var ModalMessage = Widget.extend({

    /**
     *
     * @param options
     */
    initialize: function (options) {
        var that = this;

        ModalMessage.__super__.initialize.call(that, options);
        that.getContainer().addClass('omjs-widget-modal-alert');
        that.$message = $('<div>')
            .addClass('omjs-widget-modal-alert-message')
            .appendTo(that.getContainer());

        if(options.message){
            that.setMessage(options.message)
        }

        that.getContainer().on('click', function () {
            that.hide();
        });
    },

    setMessage: function(message){
        var that = this;
        that.message = message;
        that.$message.html(that.message);
        return that;
    },

    getMessage: function(){
        return this.message;
    },

    onAdd: function(view){
        this.view = view;
    }
});

module.exports = ModalMessage;


//////////////////
// WEBPACK FOOTER
// ./src/View/Widget/ModalMessage.js
// module id = 30
// module chunks = 0